import React from "react";
import "../css/privacy.scss";

function CookiePolicy() {
  return (
    <main id="main" className="main">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title"><h1>Cookie policy</h1></div>
        <div className="shopify-policy__body"><div className="rte">
          <p>Last updated: September 14, 2026</p>
          <p>This policy explains how slayfulpawsco uses cookies and similar browser storage on this website.</p>
          <h2>Essential storage</h2>
          <p>The site uses local browser storage to remember the contents of your cart. This is necessary for the shopping experience requested by you and is not used to build an advertising profile.</p>
          <h2>Preference and analytics cookies</h2>
          <p>If optional preference or analytics tools are enabled in the future, they should be used only after any consent required in your region. This site does not claim to use an optional analytics or advertising service unless it is actually configured.</p>
          <h2>Managing storage</h2>
          <p>You can remove saved site data in your browser settings. Clearing storage will empty your locally saved cart and may reset other site preferences.</p>
          <h2>Do Not Track and browser signals</h2>
          <p>Browser privacy signals are handled according to applicable law and the capabilities of the services actually used by the site.</p>
          <h2>Contact</h2>
          <p>Questions about cookies or privacy can be sent to <a href="mailto:phase@slayfulpawsco.cloud">phase@slayfulpawsco.cloud</a>.</p>
        </div></div>
      </div>
    </main>
  );
}

export default CookiePolicy;
